import {
  FaFilePdf, FaChevronDown, FaRegEdit, FaRegNewspaper, FaTrashAlt, FaFacebook,
  FaUpload, FaSearch, FaInstagram, FaYoutube, FaLinkedin, FaQuestionCircle,
  FaRegBell, FaPlus, FaRegStar, FaHome, FaRegTimesCircle, FaEye, FaEyeSlash, FaCheck, FaCertificate, FaDownload,
  FaLightbulb
} from "react-icons/fa";
import { FaCircleUser, FaArrowLeftLong } from "react-icons/fa6";
import { BiBookmarks } from "react-icons/bi";
import { RiShieldStarLine } from "react-icons/ri";
import { FaXTwitter, FaListCheck, FaArrowRight } from "react-icons/fa6";
import { ImCross } from "react-icons/im";
import { VscJson } from "react-icons/vsc";
import { LuListEnd } from "react-icons/lu";
import { IoMdWarning } from "react-icons/io";
import { FiLogOut, FiKey } from 'react-icons/fi';
import { GoGear } from "react-icons/go";
import { MdExtension, MdOutlineLan } from "react-icons/md";
import { FaBuildingCircleCheck } from "react-icons/fa6";
import { FaServer } from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoClose, IoInformationCircle } from "react-icons/io5";

const icons = {
  addlist: LuListEnd,
  arrow: FaChevronDown,
  bell: FaRegBell,
  bookmark: BiBookmarks,
  certificate: FaCertificate,
  check: FaCheck,
  circlecross: FaRegTimesCircle,
  circleuser: FaCircleUser,
  close: IoClose,
  cross: ImCross,
  default: FaQuestionCircle,
  download: FaDownload,
  edit: FaRegEdit,
  enterprise: FaBuildingCircleCheck,
  eye: FaEye,
  eyeslash: FaEyeSlash,
  facebook: FaFacebook,
  gear: GoGear,
  home: FaHome,
  info: IoInformationCircle,
  instagram: FaInstagram,
  json: VscJson,
  key: FiKey,
  leftlongarrow: FaArrowRight,
  lightbulb: FaLightbulb,
  linkedin: FaLinkedin,
  listcheck: FaListCheck,
  loading: AiOutlineLoading3Quarters,
  logout: FiLogOut,
  longarrowleft: FaArrowLeftLong,
  network: MdOutlineLan,
  newspaper: FaRegNewspaper,
  pdf: FaFilePdf,
  plus: FaPlus,
  puzzle: MdExtension,
  search: FaSearch,
  server: FaServer,
  star: FaRegStar,
  starshield: RiShieldStarLine,
  trash: FaTrashAlt,
  upload: FaUpload,
  warning: IoMdWarning,
  xtwitter: FaXTwitter,
  youtube: FaYoutube,
};


export function Icon({ name, className }) {
  const IconComponent = icons[name?.toLowerCase()] || icons.default;
  return <IconComponent className={className} />;
}
